export default function({ store, req }) {
	let host = (req && Object.keys(req).indexOf('headers') >= 0 && Object.keys(req.headers).indexOf('host') >= 0 ) ? req.headers.host : null;
 	return store.dispatch('_GetWebSetting', host)
}